import React from 'react';
import { Grid, Card, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * SummaryStatisticsCards Component
 * Displays summary statistics cards for insights
 */
const SummaryStatisticsCards = ({ summary }) => {
  const theme = useTheme();

  if (!summary || Object.keys(summary).length === 0) {
    return null;
  }

  const cardSx = {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '10px',
    boxShadow: 'none',
    p: 2,
  };

  const labelSx = {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    mb: 1,
    display: 'block',
  };

  const valueSx = {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  };

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardSx}>
          <Typography variant="caption" sx={labelSx}>
            Total Insights
          </Typography>
          <Typography variant="h4" sx={valueSx}>
            {summary.total_insights || 0}
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardSx}>
          <Typography variant="caption" sx={labelSx}>
            Templates
          </Typography>
          <Typography variant="h4" sx={valueSx}>
            {summary.template_effectiveness_count || 0}
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardSx}>
          <Typography variant="caption" sx={labelSx}>
            Error Trends
          </Typography>
          <Typography variant="h4" sx={valueSx}>
            {summary.error_trend_count || 0}
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={cardSx}>
          <Typography variant="caption" sx={labelSx}>
            Anomalies
          </Typography>
          <Typography variant="h4" sx={valueSx}>
            {summary.anomaly_count || 0}
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
};

SummaryStatisticsCards.propTypes = {
  summary: PropTypes.object,
};

export default SummaryStatisticsCards;
